// client/src/components/marketer/cps/modals/SettlementHistoryModal.js
import React from 'react';

function SettlementHistoryModal({ open, onClose, settlement, project }) {
  if (!open || !settlement) return null;

  const rewardPerBuyer = project?.perPurchaseReward?.rewardPerBuyer || 0;
  const totalReward = settlement.settlementData.reduce((sum, d) => sum + (d.rewardAmount || 0), 0);

  return (
    <div className="mbm-overlay" style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      justifyContent: 'center',
      zIndex: 1200
    }}>
      <div
        className="mb-card mbm"
        style={{ 
          width: '90vw',
          maxWidth: 700,
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          margin: 0,
          padding: 0
        }} 
        onClick={e => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div className="mbm-head" style={{
          padding: '24px 32px',
          borderBottom: '2px solid var(--mb-border-color)',
          display: 'flex',
          justifyContent: 'space-between'
        }}>
          <h3 className="mbm-title" style={{ margin: 0 }}>
            📊 {settlement.roundNumber}회차 결산 내역
          </h3>
          <button onClick={onClose} className="mbm-close">
            ×
          </button>
        </div>
        
        {/* 본문 */}
        <div style={{ padding: '24px 32px', overflowY: 'auto' }}>
          {/* 결산 요약 */}
          <div style={{ 
            padding: '20px 24px',
            background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
            borderRadius: 'var(--mb-card-radius)',
            marginBottom: 24,
            border: '1px solid #a7f3d0'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, alignItems: 'center' }}>
              <span style={{ color: '#166534', fontSize: 15, fontWeight: 600 }}>✅ 결산 완료일</span>
              <span style={{ fontWeight: 700, color: '#15803d', fontSize: 16 }}>
                {settlement.completedAt ? new Date(settlement.completedAt).toLocaleDateString('ko-KR') : '-'}
              </span>
            </div>
            <div style={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 12,
              marginTop: 12,
              borderTop: '2px solid #86efac'
            }}>
              <span style={{ color: '#166534', fontSize: 15, fontWeight: 600 }}>💰 총 지급 포인트</span>
              <span style={{ fontWeight: 700, color: '#15803d', fontSize: 22 }}>
                {totalReward.toLocaleString()} pt
              </span>
            </div>
          </div>

          {/* 증빙 파일 목록 */}
          {settlement.proofFileUrls && settlement.proofFileUrls.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              <h4 style={{ 
                fontSize: 16, 
                fontWeight: 600,
                color: 'var(--mb-text-title)',
                marginBottom: 12
              }}>
                📎 증빙 파일
              </h4>
              <div style={{
                padding: '16px',
                background: '#f6f8fb',
                border: '1px solid var(--mb-border-color)',
                borderRadius: 'var(--mb-card-radius)'
              }}>
                {settlement.proofFileUrls.map((url, idx) => {
                  const filename = decodeURIComponent(url.split('/').pop() || `파일${idx + 1}`);
                  return (
                    <div key={idx} style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '10px 12px',
                      background: 'white',
                      borderRadius: 6,
                      marginBottom: idx < settlement.proofFileUrls.length - 1 ? 8 : 0,
                      fontSize: 13
                    }}>
                      <span style={{ 
                        flex: 1, 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis', 
                        whiteSpace: 'nowrap',
                        marginRight: 10
                      }}>
                        📄 {filename}
                      </span>
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          padding: '6px 14px',
                          background: 'var(--mb-color-primary)',
                          color: 'white',
                          borderRadius: 6,
                          textDecoration: 'none',
                          fontSize: 12,
                          fontWeight: 500,
                          whiteSpace: 'nowrap'
                        }}
                      >
                        다운로드
                      </a>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {/* 상세 내역 테이블 */}
          <div style={{ marginBottom: 16 }}>
            <h4 style={{ 
              fontSize: 16, 
              fontWeight: 600,
              color: 'var(--mb-text-title)',
              marginBottom: 12
            }}>
              인플루언서별 상세 내역
            </h4>
          </div>

          <div style={{ 
            border: '1px solid var(--mb-border-color)',
            borderRadius: 'var(--mb-card-radius)',
            overflow: 'hidden'
          }}>
            <table className="mb-table" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th style={{ fontSize: 13 }}>인플루언서</th>
                  <th style={{ fontSize: 13 }}>인정 고객 수</th>
                  <th style={{ fontSize: 13 }}>회당 리워드</th>
                  <th style={{ fontSize: 13 }}>지급 포인트</th>
                </tr>
              </thead>
              <tbody>
                {settlement.settlementData.map((data, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: 600, fontSize: 14 }}>
                      {data.userNickname || data.username || '-'}
                    </td>
                    <td style={{ fontSize: 14 }}>
                      <span style={{ fontWeight: 600, color: 'var(--mb-text-title)' }}>
                        {data.customerCount || 0}명
                      </span>
                    </td>
                    <td style={{ color: 'var(--mb-text-sub)', fontSize: 14 }}>
                      {rewardPerBuyer.toLocaleString()}pt
                    </td>
                    <td style={{ fontWeight: 700, color: 'var(--mb-color-primary)', fontSize: 15 }}>
                      {(data.rewardAmount || 0).toLocaleString()}pt
                    </td>
                  </tr>
                ))}
                {settlement.settlementData.length === 0 && (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: 40, color: 'var(--mb-text-sub)' }}>
                      결산 내역이 없습니다.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        
        {/* 하단 버튼 */}
        <div className="mbm-foot" style={{
          padding: '20px 32px',
          borderTop: '1px solid var(--mb-border-color)',
          background: '#f6f8fb',
          marginTop: 0
        }}>
          <button 
            onClick={onClose} 
            className="mb-btn mb-btn-secondary"
            style={{ padding: '10px 32px', fontSize: 15 }}
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}

export default SettlementHistoryModal;
